// T3/100A06: protección de la operación. Si una pantalla falla al dibujarse, en vez de dejar la
// app en blanco muestra un aviso con "Reintentar" e imprime el error con console.error.
// El resto de la app (menú, sesión) sigue funcionando. Solo actúa cuando ya ocurrió un error.
import React from "react";
import { Button, Result } from "antd";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.retry = this.retry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(
      `[APP] Error al mostrar la pantalla ${window.location.pathname}:`,
      error,
      info?.componentStack || ""
    );
  }

  retry() {
    this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Result
        status="warning"
        title="Esta pantalla tuvo un problema"
        subTitle="No se perdió la sesión. Reintente; si se repite, avise a soporte con la hora y la pantalla."
        extra={[
          <Button key="retry" type="primary" onClick={this.retry}>
            Reintentar
          </Button>,
          <Button key="home" onClick={() => window.location.assign("/")}>
            Ir al inicio
          </Button>,
        ]}
      />
    );
  }
}
